(() => {
  const KEY = "va-wishlist";

  const getList = () => {
    try {
      const v = JSON.parse(localStorage.getItem(KEY) || "[]");
      return Array.isArray(v) ? v : [];
    } catch (e) {
      return [];
    }
  };

  const setList = (arr) => localStorage.setItem(KEY, JSON.stringify(arr));

  const updateBadge = () => {
    const badge = document.querySelector("[data-wishlist-count]");
    if (!badge) return;

    const count = getList().length;
    badge.textContent = count;

    badge.style.display = count > 0 ? "flex" : "none";
  };

  const setActiveStates = () => {
    const list = getList();
    document.querySelectorAll("[data-wishlist-btn][data-product-handle]").forEach((btn) => {
      const handle = btn.dataset.productHandle;
      btn.classList.toggle("is-active", list.includes(handle));
    });
  };

  const refreshUI = () => {
    updateBadge();
    setActiveStates();
  };

  // Click handler (works everywhere)
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-wishlist-btn][data-product-handle]");
    if (!btn) return;

    const handle = btn.dataset.productHandle;
    if (!handle) return;

    let list = getList();

    if (list.includes(handle)) {
      list = list.filter((h) => h !== handle);
    } else {
      list.push(handle);
    }

    setList(list);
    refreshUI();
  });

  // Run on every load + Shopify section re-render
  document.addEventListener("DOMContentLoaded", () => {
  refreshUI();
  setTimeout(refreshUI, 300);
  setTimeout(refreshUI, 1200);
});

  // Back/forward cache (very important)
  window.addEventListener("pageshow", refreshUI);
  
  document.addEventListener("shopify:section:load", refreshUI);
  document.addEventListener("shopify:section:reorder", refreshUI);
  document.addEventListener("shopify:section:select", refreshUI);

  // Sync if user changed wishlist in another tab
  window.addEventListener("storage", (e) => {
  if (e.key === KEY) refreshUI();
  });


  // expose small debug helpers (optional)
  window.VA_WISHLIST = { getList, refreshUI };
})();
